import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { useRouter } from 'next/router';
import { routerPush, getIconPath } from '@tcp/core/src/utils';
import withStyles from '@tcp/core/src/components/common/hoc/withStyles';
import {
  getLabelFromCopyOrFromTranslation,
  renderLabel,
} from '@tcp/core/src/utils/labels/labelUtilty';
import { HEADER_LABELS, headerLabels } from '@tcp/core/src/utils/labels/globalHeader.labels';
import styles from '../styles/ToastModal.styles';
import Anchor from '../../../../../../common/atoms/Anchor/views/Anchor';
import ModalCloseIcon from '../../../../../../common/molecules/Modal/view/ModalCloseIcon';
import Image from '../../../../../../common/atoms/Image/views/Image';

const ToastModal = ({ duration, className, showToastModalAction }) => {
  const headerLabelsObj = getLabelFromCopyOrFromTranslation(HEADER_LABELS, headerLabels);

  const loginLabel = renderLabel(headerLabelsObj.lbl_header_login, 'lbl_header_login');
  const createAccountLabel = renderLabel(
    headerLabelsObj.lbl_create_an_account,
    'lbl_create_an_account'
  );
  const [visible, setVisible] = useState(true);
  const router = useRouter();

  useEffect(() => {
    const timer = setTimeout(() => {
      setVisible(false);
      showToastModalAction({
        duration: 0,
        showToast: false,
      });
    }, duration);

    return () => {
      clearTimeout(timer);
      showToastModalAction({
        duration: 0,
        showToast: false,
      });
    };
  }, [duration]);

  const closeFunc = () => {
    return setVisible(false);
  };

  const target = 'login';
  const pathname = router?.pathname || 'referrer';
  const successTarget = pathname;
  const href = `/home?target=${target}&successtarget=${successTarget}&fromGuestFav=true`;
  const asLogin = '/home/login';
  const asRegister = '/home/register';
  const query = {}; // Add any additional query parameters if needed
  const handleClick = (e, as) => {
    e.preventDefault();
    setVisible(false);
    showToastModalAction({
      duration: 0,
      showToast: false,
    });
    routerPush(href, as, query);
  };

  const createLink = (link, text) => {
    return (
      <Anchor
        noLink
        targetVal="_self"
        to={href}
        asPath={asLogin}
        className={'link-cls'}
        handleLinkClick={(e) => handleClick(e, link)}
      >
        {text}
      </Anchor>
    );
  };

  return (
    visible && (
      <div className={`${className} container`}>
        <div className={'icon-wrapper'}>
          <Image src={getIconPath('added-to-fav')} alt={'added to fav icon'} />
        </div>
        <div>
          <div className={'header-text'}>
            {'Added to Favorites'}
            <ModalCloseIcon className="close-modal" closeFunc={closeFunc} />
          </div>
          <div className={'body-wrapper'}>
            {createLink(asLogin, loginLabel)}
            {' or '}
            {createLink(asRegister, createAccountLabel)}
          </div>
        </div>
      </div>
    )
  );
};

ToastModal.propTypes = {
  duration: PropTypes.number.isRequired,
  showToastModalAction: PropTypes.func,
  className: PropTypes.string,
};

ToastModal.defaultProps = {
  className: '',
  showToastModalAction: () => {},
};

export default withStyles(ToastModal, styles);
